export const waitDelay = delay => new Promise( resolve => setTimeout( resolve, delay ) );

export const scheduledForEach = ( array, callback ) => {
	const runForIndex = ( index ) => {
		if ( index === array.length ) return;
		callback( array[ index ] );
		setTimeout( () => runForIndex( index + 1 ) );
	}

	setTimeout( () => runForIndex( 0 ) );
}
